import styled, { css } from 'styled-components'
import { breakpoints, Transition } from 'utils/constants'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  overflow: auto;
  padding: 60px;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media ${breakpoints.mobileMax} {
    padding: 0;
  }
`

export const Box = styled.div`
  max-width: 100%;
  width: 384px;
  margin: auto;
  padding: 20px;
  background-color: var(--t-modal-bg);
  border-radius: 8px;
  border: 1px solid var(--t-modal-border);

  @media ${breakpoints.mobileMax} {
    border-radius: 0;
  }

  ${({ $size }) =>
    $size === 'small' &&
    css`
      width: 364px;
    `}

  ${({ $size }) =>
    $size === 'mdSmall' &&
    css`
      width: 560px;
    `}

  ${({ $size }) =>
    $size === 'medium' &&
    css`
      width: 680px;
    `}

  ${({ $size }) =>
    $size === 'large' &&
    css`
      width: 60vw;
    `}

  ${({ $size }) =>
    $size === 'max' &&
    css`
      width: 70vw;
    `}

  ${({ $size }) =>
    $size === 'fullscreen' &&
    css`
      width: 100%;
    `}

  ${({ $size }) =>
    $size === 'wide' &&
    css`
      width: 100%;
      max-width: 862.5px;
    `}

  ${({ $size }) =>
    $size === 'templatesSelect' &&
    css`
      width: 100%;
      max-width: 780px;
    `}
`

export const CloseButton = styled.button`
  outline: none;
  color: var(--p-neutral-100);
  cursor: pointer;
  position: fixed;
  height: 24px;
  top: 24px;
  right: 24px;
  padding: 7px;
  background: color-mix(in srgb, var(--p-neutral-250) 20%, transparent);
  border-radius: 6px;
  transition: ${Transition.ms300};

  svg {
    display: block;
  }

  &:hover {
    color: var(--t-modal-button-close-color);
  }

  &:active {
    opacity: 0.3;
  }
`

export const ModalTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: var(--t-modal-title-color);
  margin-bottom: ${({ $hasText }) => ($hasText ? '8px' : '25px')};
`

export const ModalText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
  color: var(--t-text-primary);
  margin-bottom: 24px;
`
